import Api from '../../helpers/api';

class ActivitiesService {
	getActivities(payload) {
		return Api.call('/v2/activity/list-activity', 'get', payload)
	}
}

export default new ActivitiesService()